<template>
    <button :disabled="disabled" :type="type" class="state-button">
        <span class="inner">
            <span v-if="state === 'busy'"><svg-spinner class="spinner" :color="spinnerDark ? 'dark' : ''" /></span>
            <span class="content"><slot/></span>
        </span>
    </button>
</template>

<script>
import IconSpinner from "@/Icons/IconSpinner";
export default {
    name: "StateButton",
    components: {SvgSpinner: IconSpinner},
    props: ['disabled', 'type', 'state', 'spinnerDark']
}
</script>

<style lang="scss" scoped>
.inner{
    display: flex;
    align-items: center;
}
.spinner{
    height: 1rem;
    width: auto;
    margin-right: .5rem;
    animation: spin infinite linear 1s;
}
.content{
    flex-grow: 1;
}

@keyframes spin {
    from{transform: rotate(0deg)}
    to{transform: rotate(360deg)}
}
</style>
